<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">
            {{ $t("Cadastrar Técnico") }}
        </h1>

        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <form @submit.prevent="addItem" ref="addItem">
            <div class="row">
                <form-input
                    grid="9"
                    v-model="item.nome"
                    :required="true"
                    label="Nome"
                />
                <form-input
                    grid="3"
                    label="Data de Nascimento"
                    v-model="item.data_nascimento"
                    :required="true"
                    v-mask="'##/##/####'"
                />
                <form-input
                    grid="3"
                    v-model="item.cpf"
                    v-mask="'###.###.###-##'"
                    label="CPF"
                />
                <form-input
                    grid="3"
                    v-model="item.telefone"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    label="Telefone"
                />
                <form-input
                    grid="3"
                    v-model="item.whatsapp"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    label="Whatsapp"
                />
                <form-input grid="6" v-model="item.profissao" label="Cargo" :required="true" />
                <div class="col-md-12">
                    <h3>Informação da Unidade</h3>
                </div>
                <form-select
                    grid="12"
                    v-model="item.role"
                    :itens="roles"
                    :required="true"
                    placeholder="Selecione uma Função"
                    label="Função na Unidade/Sistema"
                />
                <form-select
                    grid="4"
                    v-model="item.regime_trabalho"
                    :itens="$root.arrays.regimeTrabalhoTecnicos"
                    placeholder="Selecione"
                    label="Regime de Trabalho"
                />

                <form-calendar
                    v-model="item.data_admissao"
                    grid="4"
                    label="Data de Vinculação"
                />

                <form-calendar
                    v-model="item.data_desvinculacao"
                    grid="4"
                    label="Data de Desvinculação"
                />

                <div class="col-md-12">
                    <h3>Dados de Acesso ao Sistema</h3>
                </div>
                <form-input
                    grid="4"
                    v-model="item.email"
                    :required="true"
                    label="E-mail"
                />

                <div class="col-md-4">
                    <b-form-group class="mb-2" label-for="password">
                        <template v-slot:label
                            >{{ $t("Senha") }}
                            <span class="text-danger">*</span></template
                        >
                        <b-input-group>
                            <b-form-input
                                :type="passwordInput"
                                id="password"
                                required
                                v-model="item.password"
                            />
                            <b-input-group-append style="height: 35px">
                                <b-button
                                    :title="$t('Show/Hide password')"
                                    @click="showPassword"
                                    class="px-2"
                                    type="button"
                                    v-b-tooltip.hover
                                    variant="primary"
                                >
                                    <i
                                        class="fas fa-fw fa-eye"
                                        v-if="passwordInput === 'password'"
                                    />
                                    <i class="fas fa-fw fa-eye-slash" v-else />
                                </b-button>
                                <b-button
                                    :title="$t('Generate new password')"
                                    @click="generatePassword"
                                    class="px-2"
                                    type="button"
                                    v-b-tooltip.hover
                                    variant="secondary"
                                >
                                    <i class="fas fa-fw fa-sync" />
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </div>
                <form-calendar
                    grid="4"
                    v-model="item.validade"
                    label="Validade do Cadastro"
                />

                <form-textarea-editor
                    v-model="item.observacoes"
                    label="Observação"
                    grid="12"
                />
            </div>

            <div class="float-right mt-3">
                <button
                    class="btn default"
                    @click.prevent="$parent.page = 'tecnicos'"
                >
                    <i class="mdi mdi-arrow-left" />
                </button>
                <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "AddTecnico",
    mounted() {
        this.getRoles();
    },
    data() {
        return {
            loading: false,
            loadingSearchUnidade: false,
            unidadesList: [],
            passwordInput: "password",
            item: {
                password: null,
                unidade: {
                    id: null,
                    value: null,
                },
            },
            settings: {},
            roles: [],
        };
    },
    methods: {
        addItem() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            this.item.unidade = this.$route.params.id;

            // if (this.item.data_admissao) {
            //   this.item.data_admissao = moment(
            //     this.item.data_admissao,
            //     "YYYY-MM-DD"
            //   ).format("YYYY-MM-DD");
            // }

            // Send request
            axios
                .post("api/dashboard/tecnicos", this.item)
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.$root.$emit("pageSelect", "tecnicos");
                })
                .catch(() => {
                    ladda.stop();
                });
        },
        // Show the password input
        showPassword() {
            if (this.passwordInput === "password") {
                this.passwordInput = "text";
            } else {
                this.passwordInput = "password";
            }
        },
        // Generate new password
        generatePassword() {
            this.item.password = window.GeneratePassword.generate({
                length: 8,
                numbers: true,
                symbols: false,
                excludeSimilarCharacters: true,
                strict: true,
            });
        },
        getRoles() {
            // Get all settings values
            axios.get("api/dashboard/users/roles").then((response) => {
                if (response.data.data) {
                    this.roles = response.data.data.map((elem) => ({
                        id: elem.id,
                        value: elem.name,
                    }));
                }

                // this.roles = response.data.data;
                this.loading = false;
            });
        },
    },
};
</script>
